import type { ReactNode } from 'react';

interface SectionTitleProps {
  title: string;
  desc?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionTitle({ title, desc, icon, action }: SectionTitleProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="flex items-start gap-3">
        {icon ? (
          <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className={`${icon} text-lg`}></i>
          </span>
        ) : null}
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {desc ? <p className="mt-1 text-sm text-foreground-500">{desc}</p> : null}
        </div>
      </div>
      {action}
    </div>
  );
}